import CobliCamPlayer from './CobliCamPlayer';

export default CobliCamPlayer;
